import React from 'react';
import { X, RefreshCw } from 'lucide-react';

const ErrorDisplay = ({ error, onRetry }) => {
    return (
        <div className="p-8 text-center bg-red-50 rounded-xl">
            <div className="flex flex-col items-center space-y-4">
                <div className="flex items-center justify-center w-12 h-12 bg-red-100 rounded-full">
                    <X className="w-6 h-6 text-red-600" />
                </div>
                <div>
                    <h3 className="text-lg font-semibold text-red-900">Error</h3>
                    <p className="text-red-700">{error}</p>
                </div>
                <button
                    onClick={onRetry}
                    className="flex items-center px-6 py-3 space-x-2 text-white transition-colors bg-red-600 rounded-lg hover:bg-red-700"
                >
                    <RefreshCw className="w-4 h-4" />
                    <span>Retry</span>
                </button>
            </div>
        </div>
    );
};

export default ErrorDisplay;